import { createSlice } from "@reduxjs/toolkit";

interface OTPState {
}

const initialState: OTPState = {
};

const otpSlice = createSlice({
  name: "otp/slice",
  initialState,
  reducers: {
  },
});

export const {
} = otpSlice.actions;

export default otpSlice.reducer;
